// extracted by mini-css-extract-plugin
export default {"routeButton":"RoutesSwitcher_routeButton__nWUq-","wrapper":"RoutesSwitcher_wrapper__UeuBj","active":"RoutesSwitcher_active__yMOb2"};